import React, { useContext, useEffect } from "react";
import styles from '../cookies/CookiesInternal.module.css';
import FooterExternal from "../../footer/FooterExternal";
import PrivacyPolicyContent from "../../privacyPolicy/PrivacyPolicyContent";
import { useNavigate } from "react-router-dom";
import { BrandCountryContext } from "../../providers/BrandCountryProvider";

export default function PrivacyPolicyInternal(){

    const {brand,handlePageChange} = useContext(BrandCountryContext);

    useEffect(() => {
        handlePageChange(window.location.pathname);
    },[]);

    const imgObject =  {
        'Premio': 'url(./imgs/home/Box__Premio_Logos_High.jpg)',
        'Vulco': 'url(./imgs/home/Box__Vulco_Logos_High.jpg)',
        'Super Service': 'url(./imgs/home/Box_SuperService_Logos_High.jpg)'
    }

    return (
        <>
            <div className={styles.container}>
                <PrivacyPolicyContent/>
            </div>
            <div className={styles.background} style={{backgroundImage: imgObject[brand]}}></div>
        </>
    )
}